import { Button, Container, Section } from '../../shared';
import React, { useState } from 'react';
import './tabs.scss';
export var Tabs = function (_a) {
    var _b;
    var id = _a.id, children = _a.children;
    var _c = useState(), selectedTab = _c[0], setSelectedTab = _c[1];
    var toggleTab = function (e) {
        var tab = e.currentTarget.getAttribute('data-value');
        setSelectedTab(tab);
    };
    var activeTab = selectedTab !== null && selectedTab !== void 0 ? selectedTab : ((_b = React.Children.toArray(children)[0]) === null || _b === void 0 ? void 0 : _b.props).title;
    return (React.createElement(Section, { headerChildren: React.createElement(React.Fragment, null, React.Children.map(children, function (child) {
            var tab = child === null || child === void 0 ? void 0 : child.props;
            var extendedClass = 'c-tab-header';
            if ((tab === null || tab === void 0 ? void 0 : tab.title) == activeTab) {
                extendedClass += ' active';
            }
            return (React.createElement("span", { className: extendedClass },
                React.createElement(Button, { key: "tab-button-".concat(tab === null || tab === void 0 ? void 0 : tab.title), icon: tab === null || tab === void 0 ? void 0 : tab.icon, iconPosition: "left", variant: "bare", type: "button", onClick: toggleTab, dataValue: tab === null || tab === void 0 ? void 0 : tab.title },
                    React.createElement("span", null, tab === null || tab === void 0 ? void 0 : tab.title),
                    (tab === null || tab === void 0 ? void 0 : tab.showNotification) == true && React.createElement("span", { className: "badge ".concat(tab === null || tab === void 0 ? void 0 : tab.extendNotificationClass) }))));
        })) }, React.Children.map(children, function (child) {
        var tab = child === null || child === void 0 ? void 0 : child.props;
        var extendedClass = 'c-tab-item';
        if ((tab === null || tab === void 0 ? void 0 : tab.title) == activeTab) {
            extendedClass += ' active';
        }
        return React.createElement(Container, { extendClass: extendedClass },
            " ",
            child,
            " ");
    })));
};
